/* eslint-disable object-curly-newline */
import Vue from 'vue';
import VueRouter from 'vue-router';

// Pages
import Dashboard from './components/pages/dashboard';

import Groups from './components/pages/groups/groups';
import ViewGroup from './components/pages/groups/view-group';
import NewGroup from './components/pages/groups/new-group';

import ViewPost from './components/pages/posts/view-post';
import EditPost from './components/pages/posts/edit-post';

import People from './components/pages/users/people';
import ViewProfile from './components/pages/users/view-profile';
import EditProfile from './components/pages/users/edit-profile';
import ViewPosts from './components/pages/users/view-posts';
import PeopleContact from './components/pages/users/people-contact';

import ChangePassword from './components/pages/users/change-password';

import FilesPage from './components/pages/files/files';

import SettingsGeneral from './components/pages/settings/general';
import SettingsUsers from './components/pages/settings/users';
import SettingsUsersInvite from './components/pages/settings/users-invite';
import SettingsNavigation from './components/pages/settings/menu';
import SettingsLogin from './components/pages/settings/login';
import SettingsSSO from './components/pages/settings/sso';

// Partials
import GlobalSearch from './components/partials/search';
import FileUpload from './components/partials/single-file-upload';
import PostFileUpload from './components/partials/post-file-upload';
import Avatars from './components/partials/avatars';
import Avatar from './components/partials/avatar';
import Comments from './components/partials/comments';
import LargePost from './components/partials/large-post';
import Editor from './components/partials/editor';
import SearchDialog from './components/partials/search-dialog';
import EventCard from './components/partials/event-card';
import CategoryModal from './components/partials/category-modal';
import PostCard from './components/partials/post-card';
import PostCardCategory from './components/partials/post-card-category';
import PostCardWide from './components/partials/post-card-wide';

import Alert from './components/partials/alert';
import ShareBtn from './components/partials/share-button';

import MediaLibrary from './components/partials/media-library';

import ContactModal from './components/partials/contact-modal';
import ContactListModal from './components/partials/contact-list-modal';

// Sidebars
import NestedPostSidebar from './components/partials/nested-post-sidebar';
import NestedFileSidebar from './components/partials/nested-file-sidebar';
import AccountSidebar from './components/partials/account-sidebar';

import Chronological from './components/pages/groups/group-types/chronological';
import KnowledgeBase from './components/pages/groups/group-types/knowledge-base';
import KnowledgeBaseCategory from './components/pages/groups/group-types/knowledge-base-category';
import Files from './components/pages/groups/group-types/files';
import Events from './components/pages/groups/group-types/events';
import Forum from './components/pages/groups/group-types/forum';

import PostChronological from './components/pages/posts/group-types/chronological';
import PostKnowledgeBase from './components/pages/posts/group-types/knowledge-base';
import PostEvents from './components/pages/posts/group-types/event';
import PostFiles from './components/pages/posts/group-types/files';
import PostForum from './components/pages/posts/group-types/forum';

import Post from './components/pages/posts/post';
import PostAnalytics from './components/pages/posts/analytics';

Vue.component('search', GlobalSearch);
Vue.component('file-upload', FileUpload);
Vue.component('post-file-upload', PostFileUpload);
Vue.component('avatars', Avatars);
Vue.component('avatar', Avatar);
Vue.component('comments', Comments);
Vue.component('large-post', LargePost);
Vue.component('editor', Editor);
Vue.component('event-card', EventCard);
Vue.component('search-dialog', SearchDialog);
Vue.component('share-button', ShareBtn);
Vue.component('category-modal', CategoryModal);
Vue.component('post-card', PostCard);
Vue.component('post-card-category', PostCardCategory);
Vue.component('post-card-wide', PostCardWide);
Vue.component('alert', Alert);
Vue.component('contact-list-modal', ContactListModal);
Vue.component('contact-modal', ContactModal);
Vue.component('media-library', MediaLibrary);

// Sidebars
Vue.component('nested-post-sidebar', NestedPostSidebar);
Vue.component('nested-file-sidebar', NestedFileSidebar);
Vue.component('account-sidebar', AccountSidebar);

// Group partials
Vue.component('chronological', Chronological);
Vue.component('knowledge-base', KnowledgeBase);
Vue.component('knowledge-base-category', KnowledgeBaseCategory);
Vue.component('files', Files);
Vue.component('events', Events);
Vue.component('forum', Forum);

// Posts
Vue.component('post-chronological', PostChronological);
Vue.component('post-knowledge-base', PostKnowledgeBase);
Vue.component('post-events', PostEvents);
Vue.component('post-files', PostFiles);
Vue.component('post-forum', PostForum);

Vue.component('post', Post);
Vue.component('post-analytics', PostAnalytics);
const routes = [
	{
		path: '/',
		component: Dashboard,
		name: 'dashboard'
	},
	{
		path: '/people',
		component: People,
		name: 'people'
	},
	{
		path: '/people/external',
		component: People,
		name: 'people-external'
	},
	{
		path: '/people/list/:list',
		component: People,
		name: 'people-list'
	},
	{
		path: '/people/list/:list/contact/:contact',
		component: PeopleContact,
		name: 'people-contact'
	},
	{
		path: '/profile/change-password',
		component: ChangePassword,
		name: 'change-password'
	},
	{
		path: '/profile/posts',
		component: ViewPosts,
		name: 'view-user-posts'
	},
	{
		path: '/profile/:user',
		component: ViewProfile,
		name: 'view-profile'
	},
	{
		path: '/profile/:user/edit',
		component: EditProfile,
		name: 'edit-profile'
	},
	{
		path: '/settings',
		component: SettingsGeneral,
		name: 'settings'
	},
	{
		path: '/settings/users',
		component: SettingsUsers,
		name: 'settings-users'
	},
	{
		path: '/settings/sso',
		component: SettingsSSO,
		name: 'settings-sso'
	},
	{
		path: '/settings/users/invite',
		component: SettingsUsersInvite,
		name: 'settings-users-invite'
	},
	{
		path: '/settings/menu',
		component: SettingsNavigation,
		name: 'settings-menu'
	},
	{
		path: '/settings/login',
		component: SettingsLogin,
		name: 'settings-login'
	},
	{
		path: '/groups/:group/edit',
		component: NewGroup,
		name: 'edit-group'
	},
	{
		path: '/groups/:group/:post',
		component: ViewPost,
		name: 'view-post',
	},
	{
		path: '/groups/:group/category/:category/:post',
		component: ViewPost,
		name: 'view-post-with-category',
	},
	{
		path: '/groups/:group/category/:category',
		component: ViewGroup,
		name: 'view-category'
	},
	{
		path: '/groups/:group/category/:category/:post/edit',
		component: EditPost,
		name: 'edit-post-with-category'
	},
	{
		path: '/groups',
		component: Groups,
		name: 'groups'
	},
	{
		path: '/groups/new',
		component: NewGroup,
		name: 'new-group'
	},
	{
		path: '/groups/:group',
		component: ViewGroup,
		name: 'view-group'
	},
	{
		path: '/groups/:group/new-post',
		component: EditPost,
		name: 'new-post'
	},
	{
		path: '/groups/:group/category/:category/new-post',
		component: EditPost,
		name: 'new-post-with-category'
	},
	{
		path: '/groups/:group/:post/edit',
		component: EditPost,
		name: 'edit-post'
	},
	// {
	// 	path: '/files',
	// 	component: FilesPage,
	// 	name: 'files'
	// },
];

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior (to, from, savedPosition){
  		return { x: 0, y: 0 }
	}
});

router.beforeEach((to, from, next) => {
    document.scrollingElement.classList.remove('search-open');

    next()
});

export default router;
